import React, { Suspense, lazy } from 'react';

const AgGridComponent = lazy(() => import('./AgGrid'));

export const AgGrid = (props) => (
  <Suspense fallback={null}>
    <AgGridComponent {...props} />
  </Suspense>
);

export * from './cellEditors';
export * from './formatters';
